// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"349":"css/admin-app.6765","4194":"css/app.6765"}[chunkId] + ".css";
};